var exports = {
  "Wm": "AvatarUltraFront.module__front___UG5JS3",
  "DU": "AvatarUltraFront.module__floating___UG5JS3",
  "MX": "AvatarUltraFront.module__half___UG5JS3",
  "e7": "AvatarUltraFront.module__mirror___UG5JS3",
  "R": "AvatarUltraFront.module__hidden___UG5JS3",
};

module.exports = exports;
